import { FormControl, FormGroup } from '@angular/forms';

export type AtLeastOne<T, U = {[K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

export type Override<What, With> = Omit<What, keyof With> & With;

export class FormGroupOfType<Type> extends FormGroup<{
  [key in keyof Type]: FormControl<Type[key]>;
}>{};
